// File: src/components/PlacementManager.tsx
import React, { useState } from 'react'
import { CampaignUnit, Placement } from '../types/types'

const PlacementManager = ({ campaignUnit, originalPlacements }: { campaignUnit: CampaignUnit; originalPlacements: Placement[] }) => {
  const [placements, setPlacements] = useState<Placement[]>(originalPlacements)
  const [editingId, setEditingId] = useState<string | null>(null)
  const [originalPlacement, setOriginalPlacement] = useState<Placement | null>(null)
  const [allowUpdate, setAllowUpdate] = useState<boolean>(false)
  const [updating, setUpdating] = useState<boolean>(false)
  const [status, setStatus] = useState(campaignUnit?.status || 'active')

  const placementOptions = {
    '': '',
    mytribe: 'MyTribe',
    whatson: "What's On",
    channel: 'Channel',
    tables: 'Tables',
    stats: 'Stats',
    playoffs: 'Playoffs',
    match: 'Match',
    lineups: 'Lineups',
    boxscores: 'Boxscores',
    cricketStats: 'Cricket Stats',
    customChannel: 'Custom Channel',
    customMatch: 'Custom Match',
  }

  const formats = {
    native: 'Native',
    square: 'Square',
    large: 'Large',
  }

  const customChannelOptions = ['National league men', 'National league women', 'OFC', 'International Football']
  const customMatchOptions = ['NZL vs MAS', 'NZL vs TRI', 'NZL vs FIJ']

  const addPlacement = () => {
    const newPlacement: Placement = {
      placement: Object.values(placementOptions)[0],
      type: Object.values(placementOptions)[0],
      format: 'native',
      priority: '0',
    }
    setPlacements([...placements, newPlacement])
    setEditingId(newPlacement.placement)
  }
  const deletePlacement = (placement: string) => {
    setPlacements(placements.filter((p) => p.placement !== placement))
    setAllowUpdate(true)
  }

  const updatePlacement = (placement: string, updates: Partial<Placement>) => {
    setEditingId(updates.placement || placement)
    setPlacements(placements.map((p) => (p.placement === placement ? { ...p, ...updates } : p)))
  }

  const savePlacement = (placement: string) => {
    setEditingId(null)
    setAllowUpdate(true)
  }

  const cancelEdit = (placement: string) => {
    if (originalPlacement) {
      setPlacements(placements.map((p) => (p.placement === placement ? originalPlacement : p)))
    }

    setEditingId(null)
  }
  const updateAdsSettings = async () => {
    setUpdating(true)
    const placementsToSave: any = {}
    placements.forEach((pl) => {
      placementsToSave[pl.placement] = { format: pl.format }
    })
    // console.log('JSON.stringify(campaignUnit)', { ...campaignUnit, placements: placementsToSave })
    // return
    try {
      const response = await fetch(`https://adsapi.tribesportsapp.com/api/campaignUnit/${campaignUnit.adUnit}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...campaignUnit, status, placements: placementsToSave }),
      })
      const result = await response.json()
      console.log('Ads settings updated:', result)
      setAllowUpdate(false)
      setUpdating(false)
    } catch (error) {
      console.error('Error updating ads settings:', error)
      setAllowUpdate(false)
      setUpdating(false)
    }
  }

  if (!placements) return null
  return (
    <div>
      {placements.map((placement: any) => (
        <div key={placement.placement} style={styles.placementRow}>
          {editingId === placement.placement ? (
            <>
              <select value={placement.placement} onChange={(e) => updatePlacement(placement.placement, { placement: e.target.value })} style={styles.select}>
                {Object.entries(placementOptions).map(([value, name]) => (
                  <option key={value} value={value} disabled={placements.find((p) => p.placement === value) ? true : false}>
                    {name}
                  </option>
                ))}
              </select>
              <select value={placement.format} onChange={(e) => updatePlacement(placement.placement, { format: e.target.value })} style={styles.select}>
                {Object.entries(formats).map(([value, name]) => (
                  <option key={value} value={value}>
                    {name}
                  </option>
                ))}
              </select>
              {(placement.type === 'Custom Channel' || placement.type === 'Custom Match') && (
                <select value={placement.customOption || ''} onChange={(e) => updatePlacement(placement.id, { customOption: e.target.value })} style={styles.select}>
                  {(placement.type === 'Custom Channel' ? customChannelOptions : customMatchOptions).map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              )}
              {/* <input
                type="number"
                value={placement.priority}
                onChange={(e) => updatePlacement(placement.placement, { priority: e.target.value })}
                style={styles.input}
                placeholder="Priority"
              /> */}
              <button onClick={() => savePlacement(placement.placement)} style={styles.button}>
                Save
              </button>
              <button onClick={() => cancelEdit(placement.placement)} style={styles.button}>
                Cancel
              </button>
            </>
          ) : (
            <>
              <div style={{ width: 100 }}>{placement.type || placementOptions[placement.placement]}</div>
              <div style={{ width: 100 }}>{placement.format || ''}</div>
              {!placementOptions[placement.placement] ? <div style={{ width: 350 }}>{placement.name || placement.placement}</div> : <div style={{ width: 350 }}></div>}
              <div style={{ width: 100 }}>
                <button
                  onClick={() => {
                    setOriginalPlacement(placement)
                    setEditingId(placement.placement)
                  }}
                  style={styles.button}
                >
                  <span role="img" aria-label="Edit">
                    ✏️
                  </span>
                </button>
                <button onClick={() => deletePlacement(placement.placement)} style={styles.button}>
                  <span role="img" aria-label="Delete">
                    ❌
                  </span>
                </button>
              </div>
            </>
          )}
        </div>
      ))}
      <button onClick={addPlacement} style={styles.addButton}>
        Add Placement
      </button>

      <div style={{ marginTop: '20px', width: '300px' }}>
        <label style={styles.label}>Status</label>
        <div style={styles.inputWrapper}>
          <select
            value={status}
            onChange={(event) => {
              setAllowUpdate(true)

              setStatus(event.target.value)
            }}
            style={{
              width: '100%',
              padding: '0.5rem',
              fontSize: '1rem',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
            }}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>
      <br style={{ clear: 'both' }} />
      <button
        disabled={!allowUpdate || updating}
        style={{ ...styles.saveButton, ...((!allowUpdate || updating) && { opacity: 0.5, cursor: 'default' }) }}
        onClick={() => {
          updateAdsSettings()
        }}
      >
        {updating ? 'Updating...' : 'Update Campaign Unit'}
      </button>
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  placementRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',
  },
  column: {},
  select: {
    marginRight: '0.5rem',
    padding: '0.25rem',
  },
  input: {
    width: '60px',
    marginRight: '0.5rem',
    padding: '0.25rem',
  },
  button: {
    marginRight: '0.5rem',
    padding: '0.25rem 0.5rem',
    backgroundColor: '#f3f4f6',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  addButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  saveButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: 50,
  },
  text: {
    flex: 1,
    marginRight: '0.5rem',
  },
}

export default PlacementManager
